import React, { HTMLAttributes } from 'react'

import { SocialLinkPreview, Text, theme } from '@hhgtech/hhg-components'
import { Carousel } from '@hhgtech/hhg-components/mantine'
import { Box } from '@mantine/core'

import { useIsMobile } from 'hooks/useIsMobile'

import {
  StyledBabyPoopDetailVideoListWrapper,
  StyledCarousel,
  StyledHeading,
} from './index.styled'

type VideoListProps = {
  title?: React.ReactNode
  description?: React.ReactNode
  videos?: {
    videoUrl: string
  }[]
  slideToShow?: number
  isAutoPlay?: boolean
} & Omit<HTMLAttributes<HTMLDivElement>, 'title'>

export const VideoList = ({
  videos,
  title,
  description,
  slideToShow = 1.2,
  isAutoPlay = false,
  ...rest
}: VideoListProps) => {
  const isMobile = useIsMobile()
  if (!videos?.length || videos.length === 0) return null
  if (videos.length === 1)
    return (
      <StyledBabyPoopDetailVideoListWrapper {...rest}>
        {title &&
          (React.isValidElement(title) ? (
            title
          ) : (
            <StyledHeading tag="h2" color={theme.colors.secondaryBase}>
              {title}
            </StyledHeading>
          ))}
        {description && (
          <Text size="p3" style={{ marginBottom: '16px' }}>
            {description}
          </Text>
        )}
        <SocialLinkPreview
          url={videos[0].videoUrl || ''}
          autoPlay={isAutoPlay}
          // style={{ maxWidth: '600px' }}
        />
      </StyledBabyPoopDetailVideoListWrapper>
    )
  if (videos.length === 2 && !isMobile)
    return (
      <Box my={16}>
        {title &&
          (React.isValidElement(title) ? (
            title
          ) : (
            <StyledHeading
              tag="h2"
              color={theme.colors.secondaryBase}
              style={{ marginBlock: 24 }}
            >
              {title}
            </StyledHeading>
          ))}
        {description && (
          <Text size="p3" style={{ marginBottom: '16px' }}>
            {description}
          </Text>
        )}

        <StyledBabyPoopDetailVideoListWrapper data-slide="2" {...rest}>
          {videos.map((video, index) => (
            <SocialLinkPreview
              key={index}
              url={video?.videoUrl || ''}
              autoPlay={isAutoPlay}
            />
          ))}
        </StyledBabyPoopDetailVideoListWrapper>
      </Box>
    )

  return (
    <StyledBabyPoopDetailVideoListWrapper {...rest}>
      {title &&
        (React.isValidElement(title) ? (
          title
        ) : (
          <StyledHeading tag="h2" color={theme.colors.secondaryBase}>
            {title}
          </StyledHeading>
        ))}
      {description && (
        <Text size="p3" style={{ marginBottom: '16px' }}>
          {description}
        </Text>
      )}

      <StyledCarousel
        slidesToShow={slideToShow}
        slideGap={isMobile ? 16 : 24}
        withIndicators
        controlSize={32}
        controlsOffset={5}
        draggable={false}
        speed={500}
      >
        {videos.map((video, index) => (
          <Carousel.Slide key={index}>
            <SocialLinkPreview
              url={video.videoUrl || ''}
              autoPlay={isAutoPlay}
            />
          </Carousel.Slide>
        ))}
      </StyledCarousel>
    </StyledBabyPoopDetailVideoListWrapper>
  )
}
